import FpDashboard from './templates/default.jsx'

export default {
  default: FpDashboard
}
